var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    class: _vm.computedItem.is_verified ? '' : 'text-danger',
    attrs: {
      "to": {
        name: 'project_show',
        params: {
          project_id: _vm.computedItem.id
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }